import urlUitls from './urlUitls.js'
import objectUtil from './objectUtil'
import template from './template'

const getInSystem = function (
  vue,
  tokenId,
  organizationCode,
  systemCode,
  url,
  domain = '',
  callback
) {
  if (!tokenId || !systemCode || !url) {
    // console.log("!tokenId ||  || !systemCode || !url",!tokenId ||  !systemCode || !url);
    return
  }
  var tempUrl = 'rest/security/auth/getTicketByToken'

  vue.$axios
    .get(tempUrl, {
      params: {
        tokenId: tokenId,
        organizationCode: organizationCode,
        systemCode: systemCode,
      },
    })
    .then((res) => {
      if (res.data.code != 200 && !res.data.data) {
        vue.$Message.error(res.data.msg)
        return false
      }
      let data = res.data.data
      if (data && data != '') {
        var openUrl = urlUitls.getFullUrl(`${domain}${url}?ticket=${data}`)
        if (callback) {
          callback(openUrl)
        } else {
          var win1 = window.open(openUrl)
          if (!win1 || !win1.location) {
            vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
          }
        }
      }
    })
    .catch((res) => {
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

const routerSystem = function (
  vue,
  tokenId,
  domain,
  itemData,
  processKey = 'process',
  ifSystem = true
) {
  const getWho = objectUtil.getValueByPath(itemData, 'parameter.pathConfig', 'path') //pathConfig: "path" 后台返回的
  //这里为了兼容后台 itemData.parameters
  const parameter = itemData?.parameter ? itemData?.parameter : itemData?.parameters //{biz: "入库通知单", coop: "国药集团上海医疗器械有限公司", phone: "", total: "￥180.00", number: "TEST-RKTZ20220100000034",…}
  let webData = itemData[processKey].web //{path: "/warehouse/inboundNotice/detail?id=:orderId&function=401010", system: "ISCC"}
  let path = webData[getWho]
  if (path && typeof parameter === 'object') {
    path = template.render(path, parameter) // 霏哥说统一使用 {{}} 模式配置
    if (path.indexOf(':') > -1) {
      // 兼容老式解析 “:” 写法
      Object.keys(parameter).forEach((im) => {
        const replaceField = ':' + im
        if (path.indexOf(replaceField) > -1) {
          path = path.replace(replaceField, parameter[im])
        }
      })
    }
  }
  let nowSystemCode = vue.$store.state.user.CurrentTicket
    ? vue.$store.state.user.CurrentTicket.system.code
    : null
  if (!webData || itemData.system.code == nowSystemCode || !ifSystem) {
    const routeArr = path.split('?')
    const querys = urlUitls.getRequestParamter(path)
    vue.$router.push({
      path: routeArr[0],
      query: {
        ids: itemData.parameter.id,
        ...querys,
      },
    })
  } else {
    getInSystem(
      vue,
      tokenId,
      itemData.organization.code,
      itemData.system.code,
      '/' + itemData.system.code.toLowerCase() + '/index.html',
      domain,
      (url) => {
        var win1 = window.open(url + '#' + path)
        if (!win1 || !win1.location) {
          vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
        }
      }
    )
  }
}
export default getInSystem
export { getInSystem, routerSystem }
